import { getCookies } from './document.cookie';
import { NormalizedCacheObject } from 'apollo-boost';
import { ApolloClient } from 'apollo-client';

import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-boost';
import { WebSocketLink } from 'apollo-link-ws';
import { split } from 'apollo-link';
import { getMainDefinition } from 'apollo-utilities';

import * as LogRocket from 'logrocket';

const LEGACY_AUTH_TOKEN = 'prof_profileid';
const FP_SESSION_COOKIE = 'fp_prof_profileid';

const WS_URL = process.env.REACT_APP_WS_URL;
const HTTP_URL = process.env.REACT_APP_HTTP_URL;
// BE root (lite.fiscalpop.com in prod / localhost:3021 in dev) hosts /logout, which clears
// both the signed and legacy cookies server-side and 302s the user away.
const LOGOUT_URL = `${(new URL(HTTP_URL || '')).origin}/logout`;

class GraphQlClientService {
    private _client: ApolloClient<NormalizedCacheObject>;

    constructor() {
        // Server reads fp_prof_profileid from the WS upgrade Cookie header; no connectionParams needed.
        const wsLink = new WebSocketLink({
            uri: WS_URL,
            options: {
                minTimeout: 10000,
                reconnect: true,
            }
        });

        const httpLink = new HttpLink({
            uri: HTTP_URL,
            fetch: window.fetch,
            credentials: 'include',
        });

        const splitLink = split(
            ({ query }) => {
                const definition = getMainDefinition(query);
                return (
                    definition.kind === 'OperationDefinition' &&
                    definition.operation === 'subscription'
                );
            },
            wsLink,
            httpLink,
        );

        this._client = new ApolloClient({
            link: splitLink,
            cache: new InMemoryCache(),
        });

        // Tab focus session checker — alerts on cross-tab account swap detected via fp_prof_profileid rotation.
        const forOnFocus = (() => {
            let prev = getCookies()[FP_SESSION_COOKIE] || '';
            return () => {
                const next = getCookies()[FP_SESSION_COOKIE] || '';
                if (!prev || !next) { prev = next; return; }
                if (prev !== next) {
                    prev = next;
                    console.log('<WinFocus> session change detected');
                    LogRocket.track('SessionMismatchError');
                    alert(`Se detectó una sessión de FiscalPOP diferente, se recargarán los datos antes de continuar.\n\nRecuerde que solo es posible tener una sesión de Personal abierta a la vez.`);
                    return window.location.reload();
                }
            };
        })();
        window.onfocus = forOnFocus;
    }

    logOut() {
        // localStorage cleanup stays client-side — BE owns cookies, but it can't reach this.
        localStorage.removeItem(LEGACY_AUTH_TOKEN);
        this._client.clearStore()
            .then(() => {
                window.location.replace(LOGOUT_URL);
            });
    }

    get client() {
        return this._client;
    }
}


const GraphQlClient = (() => {
    const client = new GraphQlClientService();
    return client;
})();
export default GraphQlClient;
